<template>
    <div>
        <div  v-if="showCategories" class="col mb-2rem span_12_of_12 span_12_of_12-tl span_12_of_12-tp span_12_of_12-sl span_12_of_12-sp standalone lw-filters-wrapper no-padding flex-item">
            <div  class="learnworlds-button-wrapper lw-filters with-flexible-parts horizontal flex align-items-center lw-content-block learnworlds-element">
                <div v-for="category in localCategories" :key="category" @click="selectCategory(category.category)" class="learnworlds-main-text filter learnworlds-main-text-small lw-brand-accent1-text-hover filter text-only" :class="{'lw-brand-accent1-border': selectedCategory == category.category}">
                    {{category.category}} <template v-if="category.count !== null">({{category.count}})</template>
                </div>               
            </div>
        </div>

        <div v-if="showSearch" class="-search-box mb-2rem col standalone span_4_of_12 span_4_of_12-tl span_12_of_12-tp span_12_of_12-sl span_12_of_12-sp standalone no-padding">
            <div class="lw-cols learnworlds-input-wrapper with-input-cols align-items-stretch no-gutter one-row one-row-tl one-row-tp one-row-sl one-row-sp">
                <div class="col no-padding span_11_of_12 span_11_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp flex-item flexible">                  
                    <form @submit.prevent="">
                    <input class="full-height learnworlds-input learnworlds-input-solid-brand learnworlds-input-small learnworlds-element"
                            :placeholder="i18n.get('common.search')"
                            type="text"
                            ref="searchInput"
                            @input="setSearchQuery"
                            >
                    </form>
                </div>
                <div class="col no-padding fsh-0 span_1_of_12 span_1_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp flex-item flexible">
                    <button class="only-icon learnworlds-button learnworlds-button-solid-brand learnworlds-element full-size learnworlds-button-small">
                        <span class="learnworlds-icon fas fa-search"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>            
</template>
<script>
export default {
    props:{
        blogPostCategories:{
            type: Array,
            default: []
        },
        selectedCategory:{
            type: String,
            default: ''            
        },
        showSearch: {
            type: Boolean,
            default: false
        },
        showCategories: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        localCategories(){
            return [
                {'category': this.i18n.get('blog.all'), count: null},   
                ...this.blogPostCategories
            ]            
        }
    },
    methods:{
        selectCategory(value){
            if(value == this.i18n.get('blog.all')){
                value = null;
            }            
            this.$emit('selectCategory', value)
        },
        setSearchQuery(value){
            this.$emit('setSearchQuery', value)
        }
    }
}
</script>